import isEmail from "validator/es/lib/isEmail";

class ExporterCreationDto {
    beneficiaryCode
    phone
    fax
    email
    nameEnglish
    nameChinese
    addressEnglish
    addressChinese

    static getRules() {
        const emailValidator = (value) => {
            if (!value) {
                return new Promise(resolve => resolve(true))
            } else if (!isEmail(value)) {
                return new Promise(resolve => resolve(false))
            } else {
                return new Promise(resolve => resolve(true))
            }
        }

        return {
            beneficiaryCodeRule: [
                {required: true, message: '请输入3-8位数字、字母组合的出口商编码', trigger: 'onBlur', pattern: /^[a-zA-Z0-9]{3,8}$/}
            ],
            nameChineseRule: [
                {required: true, message: '请输入中文名称', trigger: 'onBlur'}
            ],
            nameEnglishRule: [
                {required: true, message: '请使用英文标点及字母', trigger: 'onBlur',pattern: /^[a-z_A-Z0-9-.!@#$%\\^&*)(+={}[\]/",'<>~·`?:;|\s]+$/}
            ],
            addressChineseRule: [
                {required: true, message: '请输入中文地址', trigger: 'onBlur'}
            ],
            addressEnglishRule: [
                {required: true, message: '请使用英文标点及字母', trigger: 'onBlur',pattern: /^[a-z_A-Z0-9-.!@#$%\\^&*)(+={}[\]/",'<>~·`?:;|\s]+$/}
            ],
            emailRule: [
                {message: '邮箱格式不正确', validator: emailValidator, trigger: "onBlur"}
            ],
        }
    }
}

export default ExporterCreationDto